import { ApplicationRef, Component, OnInit } from '@angular/core';
import { AccessService } from './access/access.service';
import { NotificationsService } from './private/notifications/notifications.service';
import { MessagingService } from './shared/notifications/messaging.service';
import { SnackbarService } from './shared/notifications/snackbar.service';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  // Set variables
  private userId: string;

  constructor(private accessService: AccessService, private messagingService: MessagingService, public notificationsService: NotificationsService, public snackbarService: SnackbarService, private swUpdateService: SwUpdate, private router: Router, private activatedRoute: ActivatedRoute, private titleService: Title, private appRef: ApplicationRef) {
    this.appUpdates();
    this.checkAppUpdates();
  }

  ngOnInit(): void {
    // Set title for page
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      var route = this.getChild(this.activatedRoute);
      route.data.subscribe(data => {
        if (data.title) {
          this.titleService.setTitle(data.title + ' - Parity Communities');
        } else {
          this.titleService.setTitle("Parity Communities - Come let's build an inclusive world!");
        }
      });
    });

    // Check user authentication on every route
    this.accessService.autoAuthUser();

    // Check user
    this.userId = this.accessService.getUserId();
    if (this.userId) {
      // Recieve push message 
      this.messagingService.receiveMessage();
      this.messagingService.currentMessage.subscribe((message) => {
        if (message) {
          this.snackbarService.pushSuccess(message.notification.body, 'Dismiss', 'bottom', 10000);
        }
      });
    }
  }

  // Get child title
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  // Run for app been updated
  appUpdates() {
    if (!this.swUpdateService.isEnabled) {
      console.log("Service not enabled");
      return;
    }
    this.swUpdateService.available.subscribe((event) => {
      if (confirm("App update is avaible. Please update your app")) {
        this.swUpdateService.activateUpdate().then(() => location.reload());
      }
    });
  }

  // Check app updates
  checkAppUpdates() {
    this.appRef.isStable.subscribe((isStable) => {
      if (isStable) {
        const timeInterval = interval(8 * 60 * 60 * 1000);
        timeInterval.subscribe(() => {
          this.swUpdateService.checkForUpdate().then(() => console.log("Checked"));
          console.log("Updated checked");
        })
      }
    });
  }

}
